/**
 * Links that hand a contact to the device: a WhatsApp chat, a call, or an
 * e-mail. Shared by the driver portal, the dispatcher's board and the
 * admin's portal-access hand-over.
 *
 * Each one returns '' when there is nothing to reach, so a screen can render
 * NOTHING rather than a control that goes nowhere.
 */

/** wa.me takes digits only — no spaces, no leading +. '' when there is no number. */
export const whatsappUrl = (phone, text = '') => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  return text
    ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${digits}`;
};

/** tel: link, whitespace stripped. '' when there is no number. */
export const telUrl = (phone) => (phone ? `tel:${String(phone).replace(/\s/g, '')}` : '');

/**
 * mailto: link, trimmed. '' when there is no address.
 *
 * The counterpart to `telUrl` for the one contact that is written to rather
 * than rung: a partner's office. Deliberately no subject and no body — the
 * office writes its own, and a prefilled one would have to guess at a
 * language and a booking reference the link does not know.
 */
export const mailUrl = (email) => {
  const address = String(email || '').trim();

  return address ? `mailto:${address}` : '';
};
